<template>
	<div
		class="time-picker"
		:class="{
			'time-picker--disabled': disabled,
			'time-picker--empty': !times.length,
			'time-picker--no-selection': !value,
			'time-picker--narrow': narrow,
		}"
	>
		<FormInputSelect
			:value="value"
			:options="enhancedTimes"
			:disabled="disabled"
			:readonly="readonly"
			:label="label"
			@input="onInput"
		/>
	</div>
</template>

<script>
import FormInputSelect from '@/components/FormInputSelectCustom';

export default {
	components: {
		FormInputSelect
	},
	props: {
		narrow: Boolean,
		disabled: Boolean,
		readonly: Boolean,
		label: String,
		value: {
			default: "12:00"
		},
		times: {
			type: Array
		}
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	data() {
		return {

		}
	},
	computed: {
		enhancedTimes() {
			return this.times
				? this.times
					.map(t => {
						if (typeof t === 'object') {
							return t
						}

						return {
							value: t,
							label: t,
							disabled: false,
						};
					})
				: []
		}
	},
	methods: {
		onInput(value) {
			this.$emit('input', value);
		},
	}
}
</script>

<style>

</style>